import React from 'react'
import ChangeUser from './ChangeUser'
import { getDateAndTimeText } from '../../helpers/date/dateHelper'
import ChangeType from './ChangeType'
import CommentIcon from '@mui/icons-material/Comment';

const ChangeData = ({ change }) => {

    // console.log('change', change)
  return (
    <div>
        <div className='changesBlock__one-header'>
            <div>
                <ChangeUser
                    user={change.user}
                />
                <ChangeType 
                    type={change.type}
                />
            </div>
            <span className='changesBlock__one-date'>
                {getDateAndTimeText(change.date)}
            </span>
        </div>
        <div className='changesBlock__one-objectName'>
            <div>
                {change.objName} (ID: {change.objectId})
            </div>
        </div>
        {
            change.comment ?
                <div className='changesBlock__one-comment'>
                    <CommentIcon />
                    <p>{change.comment}</p>
                </div>
            : ''
        }
    </div>
  )
}

export default ChangeData